<template>
  <DialogComponent
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
    v-loading="processing"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Toll Free Request</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="submitEdit" v-if="allowSubmit"
            >Submit</el-button
          >
          <el-button type="default" @click="cancelOperation"> Cancel</el-button>
        </div>
      </div>
    </div>
    <el-form>
      <recent-audits :record="selectedPortOrder" service="Port Request" />

      <div v-if="!processing" class="mb-10">
        <h2 class="form-section-header">
          Order number summary -
          {{ selectedPortOrder ? selectedPortOrder.id : "" }}
        </h2>
      </div>

      <vxe-grid
        class="vxe-table mt-10"
        round
        border="inner"
        ref="xGrid"
        height="250px"
        auto-resize
        empty-text="No Data"
        show-overflow="tooltip"
        highlight-hover-row
        :data="editOrderData"
        :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
        :columns="tableColumnsEdit"
      />
    </el-form>
    <div class="order-note mt-10">
      <el-button
        class="table-action-button"
        icon="el-icon-edit"
        @click="noteFieldActive = !noteFieldActive"
      />
      <span class="black-text pl-10">Add order note</span>
      <el-input
        type="textarea"
        placeholder="Enter order notes"
        v-if="noteFieldActive"
        v-model="editForm.orderNote"
        @change="editedOrderNote"
        :autosize="{ minRows: 4 }"
      >
      </el-input>
    </div>
    <div class="order-notes" v-if="editForm.orderNotes">
      <el-button
        class="table-action-button"
        icon="el-icon-tickets"
        @click="viewNotesActive = !viewNotesActive"
      />
      <span class="black-text pl-10">View order notes</span>
      <div class="notes-container" v-if="viewNotesActive">
        <div
          class="note-item black-text"
          v-for="note in editForm.orderNotes"
          :key="note.noteId"
        >
          <p class="note-message">
            {{ note.insertUser }} - {{ note.insertDate }}
            <br />
            <span class="pt-5">{{ note.note }}</span>
          </p>
        </div>
      </div>
    </div>

    <div v-if="allOrderDocs && allOrderDocs.length" class="order-docs">
      <h2 class="form-section-header mt-10 mb-10">
        View / Download Order Documents
      </h2>
      <vxe-grid
        class="vxe-table"
        round
        border="inner"
        ref="xGrid"
        height="250px"
        auto-resize
        empty-text="No Data"
        show-overflow="tooltip"
        highlight-hover-row
        :data="orderDocs"
        :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
        :columns="orderDocsColumns"
        :loading="orderDocsLoading"
      />
    </div>

    <div v-if="editVisible" class="upload-docs">
      <h2 class="form-section-header">Attach LOA</h2>
      <el-upload
        class="mt-10"
        action=""
        :auto-upload="false"
        :multiple="true"
        :on-change="onLoaUpload"
      >
        <el-button size="mini" type="primary">Click to upload</el-button>
      </el-upload>

      <h2 class="form-section-header">Attach Recent Bill</h2>
      <el-upload
        class="mt-10"
        action=""
        :auto-upload="false"
        :multiple="true"
        :on-change="onRecentBillUpload"
      >
        <el-button size="mini" type="primary">Click to upload</el-button>
      </el-upload>
    </div>
  </DialogComponent>
</template>

<script>
import DialogComponent from "@/components/CustomModalComponent";
import RecentAudits from "@/components/RecentAudits";
import { phoneNumberFormatter } from "@/globals/globals";
export default {
  name: "TollFreeEditForm",

  props: {
    editVisible: { required: true },
    processing: { required: true },
    selectedPortOrder: { required: true },
    clearFields: { required: true },
  },

  components: {
    DialogComponent,
    RecentAudits,
  },

  data() {
    return {
      noteFieldActive: false,
      viewNotesActive: false,
      editOrderData: [],
      editMade: false,
      allSummaryNumbers: [],
      allOrderDocs: [],
      orderDocs: [],
      orderDocsLoading: false,
      docs: [],
      editForm: {
        orderNote: "",
        orderNotes: [],
      },
      orderDocsColumns: [
        {
          field: "documentId",
          title: "Id",
          minWidth: 50,
          sortable: true,
          showOverflow: true,
        },
        {
          field: "documentName",
          title: "Name",
          minWidth: 250,
          sortable: true,
          showOverflow: true,
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div>
                  <el-tooltip placement="top" content="Download">
                    <el-button
                      id={"edit-" + row.id}
                      icon="el-icon-download"
                      onClick={() => this.downloadDoc(row)}
                      class="table-action-button icon-blue"
                    />
                  </el-tooltip>
                </div>,
              ];
            },
          },
        },
      ],
      tableColumnsEdit: [
        {
          field: "telephoneNumber",
          title: "Number",
          minWidth: 150,
          sortable: true,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [<span>{this.numberFormatter(row.telephoneNumber)}</span>];
            },
          },
        },
        {
          field: "tnStatus",
          title: "Status",
          minWidth: 150,
          sortable: true,
          showOverflow: true,
        },
      ],
    };
  },

  computed: {
    allowSubmit() {
      return this.editMade || this.docs.length;
    },
  },

  watch: {
    selectedPortOrder: {
      immediate: true,
      handler(val) {
        if (val) {
          const { tnGroups, orderDocs, orderNotes } = val;
          this.editOrderData = [...tnGroups];
          this.allSummaryNumbers = [...tnGroups];
          this.orderDocs = [...orderDocs];
          this.allOrderDocs = [...orderDocs];
          this.editForm.orderNotes = orderNotes;
        }
      },
    },

    clearFields: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetFields();
        }
      },
    },
  },

  methods: {
    numberFormatter(val) {
      return val ? phoneNumberFormatter(val) : val;
    },

    resetFields() {
      this.noteFieldActive = false;
      this.viewNotesActive = false;
      this.editOrderData = [];
      this.editMade = false;
      this.allSummaryNumbers = [];
      this.allOrderDocs = [];
      this.orderDocs = [];
      this.orderDocsLoading = false;
      this.docs = [];
      this.editForm = {
        orderNote: "",
        orderNotes: [],
      };
    },

    editedOrderNote() {
      this.editMade = !(
        this.editForm.orderNote === null || this.editForm.orderNote === ""
      );
    },

    onLoaUpload(file) {
      this.docs.push(file);
    },

    onRecentBillUpload(file) {
      this.docs.push(file);
    },

    downloadDoc({ documentName, fileContent, mimeType }) {
      this.orderDocsLoading = true;

      const linkSource = `data:${mimeType};base64,${fileContent}`;
      const link = document.createElement("a");
      link.href = linkSource;
      link.download = documentName;
      link.click();
      this.orderDocsLoading = false;
    },

    submitEdit() {
      const formData = new FormData();
      formData.append(
        "orderRef",
        this.selectedPortOrder.customerOrderReference
      );
      formData.append("orderNote", this.editForm.orderNote);
      this.docs.forEach((file) => {
        formData.append("docs", file.raw);
      });

      this.$emit("editOrder", formData);
    },

    cancelOperation() {
      this.$emit("cancelOperation");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-header-layout {
  z-index: 1000;
}

.order-note,
.order-notes {
  max-width: 600px;
  margin: 5px auto;
  font: {
    size: 11pt;
  }
}

.order-note {
  margin-top: 15px;
}

.notes-container {
  margin-top: 10px;
  max-height: 250px;
  overflow: auto;
  border: 1px solid #dcdfe6;
  padding: 5px 10px;
}

.order-docs,
.upload-docs,
.vxe-table {
  max-width: 600px;
  margin: auto;
}

.order-docs {
  margin-top: 20px;
}

.upload-docs {
  margin-top: 20px;
}

.search-doc-input {
  width: 275px;
}
</style>
